/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const sendTelegramOidcTestDmResponseSchema = z.object({
  success: z.boolean(),
});

export type ISendTelegramOidcTestDmResponse = z.infer<typeof sendTelegramOidcTestDmResponseSchema>;
